const Warning = ({
  size = 20,
  color = "currentColor",
}: {
  size?: number;
  color?: string;
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.7875 2L18.67 6.88252V13.7875L13.7875 18.67H6.88252L2 13.7875V6.88252L6.88252 2H13.7875ZM6.82487 9.45694V11.2117H13.8438V9.45694H6.82487Z"
        fill={color}
      />
    </svg>
  );
};

export default Warning;
